module.exports = __webpack_public_path__ + "img/icon_patent_hk.1a4e847e.png";